import React from 'react';
import { Link } from 'react-router-dom';
import { homePageStyles } from './HomePage.styles';
import { EXPLORE_PRIVACY_POLICY_URL } from '../../config/legalUrls';

const Footer = () => {
  return (
    <div style={homePageStyles.footer}>
      <p style={{ margin: 0, fontSize: 13, opacity: 0.72, lineHeight: 1.45 }}>
        <Link to="/about" style={{ color: 'var(--color-primary)', fontWeight: 700 }}>
          About Explore
        </Link>
        {' · '}
        <a
          href={EXPLORE_PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'var(--color-primary)', fontWeight: 700 }}
        >
          Privacy Policy
        </a>
        {' · '}
        Educational use — adult supervision recommended. Not a social network. Features may change over time.
      </p>
    </div>
  );
};

export default Footer; 